import { useSnackbar } from "notistack";
import { Category } from "../../../domain/model/Category";
import { useEffect, useState } from "react";
import { GetAllCategoriesUseCase } from "../../../domain/usecase/category/getAll/GetAllUseCase";
import { State } from "../../../domain/model/ResponseState";

export function CategoriesViewModel(
  getAllCategoriesUseCase: GetAllCategoriesUseCase,
) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);

  const [categories, setCategories] = useState<Array<Category> | undefined>();

  useEffect(() => {
    fetchCategories();
  }, []);

  async function fetchCategories() {
    setLoading(true);
    const response = await getAllCategoriesUseCase.invoke();
    switch (response.responseState) {
      case State.Success:
        setCategories(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    setLoading(false);
  }
  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return { categories, isLoading, setLoading };
}
